import "./BrandsGrid.scss";

//Images
import Axion from "Assets/images/Logo-empresas/Logo_SF_Axion.png";
import Cargill from "Assets/images/Logo-empresas/Logo_SF_Cargill.png";
import Dow from "Assets/images/Logo-empresas/Logo_SF_Dow.png";
import Mega from "Assets/images/Logo-empresas/Logo_SF_MEGA.png";
import Oiltanking from "Assets/images/Logo-empresas/Logo_SF_Oiltanking.png";
import Oldelval from "Assets/images/Logo-empresas/Logo_SF_Oldelval.png";
import Pae from "Assets/images/Logo-empresas/Logo_SF_Pae.png";
import Pampa from "Assets/images/Logo-empresas/Logo_SF_Pampa.png";
import Profertil from "Assets/images/Logo-empresas/Logo_SF_Profertil.png";
import Puerto from "Assets/images/Logo-empresas/Logo_SF_Puerto.png";
import TGS from "Assets/images/Logo-empresas/Logo_SF_TGS.png";
import Unipar from "Assets/images/Logo-empresas/Logo_SF_Unipar.png";
import Viterra from "Assets/images/Logo-empresas/Logo_SF_Viterra.png";
import YPF from "Assets/images/Logo-empresas/Logo_SF_YPF.png";
import Trafigura from "Assets/images/Logo-empresas/Logo_SF_Trafigura.png";
import { useTranslation } from "react-i18next";

export default function BrandsGrid() {
  const { t } = useTranslation();
  const arrImg = [
    TGS,
    Mega,
    Dow,
    YPF,
    Pae,
    Pampa,
    Oiltanking,
    Trafigura,
    Oldelval,
    Axion,
    Profertil,
    Unipar,
    Puerto,
    Viterra,
    Cargill,
  ];
  return (
    <section className="brandsGrid">
      <h2 className="title">{t("clients")}</h2>
      <div className="brandsGrid__container">
        {arrImg.map((img) => (
          <img key={img} src={img} alt="Brand Logo" />
        ))}
      </div>
    </section>
  );
}
